import { render } from "./ReturnPortalReturnEntireOrder.vue?vue&type=template&id=6675e92c"
import script from "./ReturnPortalReturnEntireOrder.vue?vue&type=script&lang=js"
export * from "./ReturnPortalReturnEntireOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__